import { CircularProgress, makeStyles } from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import { getNamespace } from '../../utils/storage';
import usePermissions from '../../hooks/usePermissions';
import { useDispatch, useSelector } from 'react-redux';
import { getUsers } from '../../redux/User/UserAction';
import ManageUsersHeader from '../../components/Setting/ManageUsers/ManageUsersHeader';
import UsersTable from '../../components/Setting/ManageUsers/UsersTable';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import { GET_USERS } from '../../redux/User/UserType';
import MessagesContext from '../../contexts/messagesContext';
import LanguageContext from '../../contexts/languageContext';

const styles = makeStyles({
    container: {
        maxHeight: 'calc(100vh - 100px)',
        overflow: 'auto',
        marginTop: '-24px',
        marginBottom: '-24px',
        marginInlineEnd: '-24px',
        paddingTop: '24px'
    },
    row: {
        display: 'grid',
        gridTemplateColumns: '200px 200px 150px 150px 150px 100px 125px 125px 125px'
    },
    title: ({ rtl }) => ({
        background: '#fff',
        borderBottom: '1.5px solid rgba(206, 210, 214, 0.8)',
        paddingBottom: '8px',
        color: '#545e66',
        fontWeight: 'bold',
        '&:first-child': {
            position: 'sticky',
            right: rtl ? '0' : 'unset',
            left: !rtl ? '0' : 'unset'
        }
    }),
    titleWrapper: {
        position: 'sticky',
        top: '-24px',
        zIndex: '2'
    },
    tableContainer: {
        position: 'relative',
        zIndex: '2'
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '62vh'
    }
});
const ManageUsers = () => {
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const dispatch = useDispatch();
    const loadingSelector = createLoadingSelector(GET_USERS.REQUEST);
    const isLoading = useSelector(loadingSelector);
    const { messages } = useContext(MessagesContext);
    const users = useSelector((state) => state.user.users);
    const { titles } = usePermissions();

    useEffect(() => {
        const namespace = getNamespace();
        dispatch(getUsers(namespace));
    }, []);
    return (
        <div className={'container'}>
            <div className={classes.container}>
                <ManageUsersHeader />
                {isLoading && (users === null || users === undefined) ? (
                    <div className={classes.loadingContainer}>
                        <CircularProgress />
                    </div>
                ) : !users?.length || users === null || users === undefined ? (
                    <div className={classes.loadingContainer} data-testid="notFoundUsers">
                        <span>{messages.notFoundUser}!</span>
                    </div>
                ) : (
                    <div className={classes.tableContainer}>
                        <div className={`${classes.row} ${classes.titleWrapper}`}>
                            {titles.map((item) => (
                                <div key={item.id} className={classes.title}>
                                    {item.title}
                                </div>
                            ))}
                        </div>
                        <div>
                            {users?.map((item) => (
                                <div key={item.id} className={classes.row}>
                                    <UsersTable item={item} />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ManageUsers;
